"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { useMediaQuery } from "../hooks/useMediaQuery";
import IntroHeader from "../intro/components/IntroHeader";
import StaticWorkGrid from "./components/StaticWorkGrid";

// Lazy load Three.js canvas only on desktop to reduce bundle size on mobile
const InviteCanvas = dynamic(() => import("./components/InviteCanvas"), {
	ssr: false,
});

export default function WorkPage() {
	// Only load 3D canvas on desktop (768px+)
	const isDesktop = useMediaQuery("(min-width: 768px)");
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	// Handle Lenis instance when switching between desktop/mobile
	useEffect(() => {
		if (!mounted) return;

		const mainLenis = (
			window as Window & {
				lenisInstance?: { start?: () => void; stop?: () => void };
			}
		).lenisInstance;

		// Small delay to ensure DOM has updated
		const timer = setTimeout(() => {
			if (isDesktop) {
				// On desktop, restart main Lenis if it exists
				if (mainLenis && typeof mainLenis.start === "function") {
					mainLenis.start();
				}
			} else {
				// On mobile, stop main Lenis (StaticWorkGrid has its own ReactLenis)
				if (mainLenis && typeof mainLenis.stop === "function") {
					mainLenis.stop();
				}
			}

			// Reset scroll position
			window.scrollTo(0, 0);
		}, 100);

		return () => clearTimeout(timer);
	}, [isDesktop, mounted]);

	return (
		<div
			className={`relative h-screen w-screen bg-white ${isDesktop ? "overflow-hidden" : ""}`}
		>
			<div className="pointer-events-none fixed inset-x-0 top-0 z-40 p-4">
				<IntroHeader />
			</div>
			{/* Only render the component needed for current viewport */}
			{isDesktop ? <InviteCanvas /> : <StaticWorkGrid />}
		</div>
	);
}
